import React, { Suspense, lazy, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import Breadcrumbs from '@root/components/v2/global/breadcrumbs';
import PageContainer from '@root/components/v2/layout/PageContainer';
import PageHeader from '@root/components/v2/layout/PageHeader';
import { DATABASE_SECURITY_TABS } from '@root/constants/moduleTabs';
import { useQuery } from '@root/hooks/useQuery';
const pages = { overview: lazy(() => import('./index')), exceptions: lazy(() => import('./pages/exceptions')) };
export default function DatabaseSecurityModule() {
  const query = useQuery(); const history = useHistory(); const raw = query.get('tab');
  const tab = useMemo(() => DATABASE_SECURITY_TABS.resolve(query.toString()), [query]);
  useEffect(() => { if (raw !== tab) { const params = new URLSearchParams(query.toString()); params.set('tab', tab); history.replace(`${DATABASE_SECURITY_TABS.basePath}?${params}`); } }, [history, query, raw, tab]);
  const Page = pages[tab];
  return <PageContainer><PageHeader title={<Breadcrumbs breadcrumbs={[{ title: 'Database Security', path: DATABASE_SECURITY_TABS.path(tab) }]} />} /><Suspense fallback={null}><Page contentOnly /></Suspense></PageContainer>;
}
